import { MaskedLine, Reveal } from "./Reveal";

const PageHeader = ({ overline, lines, intro, testid }) => (
  <section className="relative border-b border-zinc-800/60 blueprint-grid overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 pt-44 pb-20">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500 flex items-center gap-3">
          <span className="w-10 h-px bg-[#C5A059]" />
          {overline}
        </p>
      </Reveal>
      <h1
        data-testid={testid}
        className="mt-8 font-display font-extrabold uppercase tracking-tight leading-[1.02] text-zinc-50 text-4xl sm:text-5xl lg:text-6xl"
      >
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.15 + i * 0.14}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {intro && (
        <Reveal delay={0.55}>
          <p className="mt-8 max-w-2xl text-base text-zinc-400 leading-relaxed font-light">{intro}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHeader;
